import CountUp from "react-countup";
import React, { useEffect, useState } from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  RoundsNBlackout,
  InfoMain,
  InfoDiv,
  ButtonRequest,
  InputAddIndustry,
  UserDiv,
  ListPlayers,
  ContainerStock,
  CardInsumo,
  Wrapper
} from "./style";
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from "react-dom/cjs/react-dom.development";
import { useUser } from "../../../providers/UserContext";


const imagesProduto = [
  "./images/sausage_pcp.svg",
  "./images/chicken.svg",
  "./images/cut_chicken_pcp.svg",
  "./images/fries_pcp.svg"
]

const SetupIndustry = () => {

  const [produtos, setProdutos] = useState([])
  const [rodada, setRodada] = useState({})
  const [jogo, setJogo] = useState(null)
  const [industries, setIndustries] = useState(null)
  const [industriesBase, setIndustriesBase] = useState([])
  const [showInputToAddIndustry, setShowInputToAddIndustry] = useState(false)
  const [nameIndustry, setNameIndustry] = useState('')
  const [showLista, setShowLista] = useState(false)
  const [idIndustria, setIdIndustria] = useState(0)
  const [showAllUsers, setShowAllUsers] = useState(false)
  const [listaPlayers, setListaPlayers] = useState(null)
  const [listaUsers, setListaUsers] = useState(null)
  const [insumos, setInsumos] = useState([])
  const [pernil, setPernil] = useState(0)
  const [batataInsumo, setBatataInsumo] = useState(0)
  const [linguica, setLinguica] = useState(0)
  const [frango, setFrango] = useState(0)
  const [frangoCorte, setFrangoCorte] = useState(0)
  const [batata, setBatata] = useState(0)
  const [sacoPlastico, setSacoPlastico] = useState(0)
  const [caixaPapelao, setCaixaPapelao] = useState(0)
  const [frangoP, setFrangoP] = useState(0)
  const [frangoL, setFrangoL] = useState(0)
  const [condimento, setCondimento] = useState(0)
  const [loading, setLoading] = useState(false)
  const { user } = useUser()

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  //lista todos os jogadores da industria
  function listAllPlayers(id) {

    setIdIndustria(id)
    setShowLista(!showLista)
    setShowAllUsers(false)

    api.get(`/api/usuario/listarPorIndustria/${id.industria}`)
      .then(response => setListaPlayers(response.data))
      .catch(error => {
        return Promise.reject(error)
      })

    try {
      api.get(`/api/rodada/obterRodadaAtiva/${jogo?.jogo}`)
        .then(response => setRodada(response.data))
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchProducts() {
    try {
      api.get("/api/produto/listarTodos")
        .then(response => {
          const data = response.data
          data.pop()
          setProdutos(data)
        })
    } catch (error) {
      console.log(error)
    }
  }

  //lista de usuarios sem industria
  function listAllUsers() {

    window.scrollTo(0, -1000);

    setShowAllUsers(true)

    api.get(`/api/usuario/listarSemIndustria/${jogo?.jogo}`)
      .then(response => setListaUsers(response.data))
      .catch(error => {
        return Promise.reject(error)
      })
  }

  function addUserToIndustry(user, industry) {

    api.get(`/api/usuario/adicionarUsuarioIndustria/${industry.industria}/${user.usuario}`)
      .then(response => {
        console.log(response)
        api.get(`/api/usuario/listarSemIndustria/${jogo?.jogo}`)
          .then(response => {
            setListaUsers(response.data)
            api.get(`/api/usuario/listarPorIndustria/${idIndustria.industria}`)
              .then(response => setListaPlayers(response.data))
              .catch(error => {
                return Promise.reject(error)
              })
          })
          .catch(error => {
            return Promise.reject(error)
          })
      })
      .then(console.log(industry.industria, user.usuario))
  }

  const handleDataProduto = (produtoState, codJogo, produto, industryId) => {

    const dataProduto = {
      "codJogo": codJogo,
      "codIndustria": industryId,
      "produto": produto,
      "quantidade": produtoState
    }

    return dataProduto

  }

  const handleDataInsumo = (insumoState, codJogo, insumo, industria) => {

    const dataInsumo = {
      "codIndustria": industria,
      "codJogo": codJogo,
      "insumo": insumo,
      "quantidade": insumoState
    }

    return dataInsumo

  }

  async function handleAddIndustry() {

    if (nameIndustry.trim().length === 0) return

    const data = {
      "batata": 0,
      "aluguel": 250000,
      "codJogo": jogo.jogo,
      "corteFrango": 0,
      "frangoCarcaca": 0,
      "funcCompras": 0,
      "funcControleQualidade": 0,
      "funcDiretorGeral": 0,
      "funcEncContabilidade": 0,
      "funcEncLogistica": 0,
      "funcEncRH": 0,
      "funcEncTesouraria": 0,
      "funcGestorAdm": 0,
      "funcGestorComercial": 0,
      "funcGestorFin": 0,
      "funcGestorLogistica": 0,
      "funcGestorProducao": 0,
      "funcOperador": 0,
      "funcVendedor": 0,
      "gerador": 0,
      "investimentoInicial": 10000000,
      "investimentoSaldo": 10000000,
      "linguica": 0,
      "nome": nameIndustry,
    }

    try {
      setLoading(true)
      const res = await api.post("/api/industria/cadastrar", data)

      const insumosPromises = insumos.map(insumo => {
        switch (insumo.nome) {
          case "Pernil Suíno":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(pernil, jogo.jogo, { "insumo": 4 }, res.data.industria))
          case "Caixa (Papelão)":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(caixaPapelao, jogo.jogo, { "insumo": 5 }, res.data.industria))
          case "Embalagem Plástica":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(sacoPlastico, jogo.jogo, { "insumo": 6 }, res.data.industria))
          case "Condimento":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(condimento, jogo.jogo, { "insumo": 7 }, res.data.industria))
          case "Frango P":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(frangoP, jogo.jogo, { "insumo": 8 }, res.data.industria))
          case "Frango L":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(frangoL, jogo.jogo, { "insumo": 9 }, res.data.industria))
          case "Batata Frita":
            return api.post("/api/estoqueInsumo/cadastrar", handleDataInsumo(batataInsumo, jogo.jogo, { "insumo": 10 }, res.data.industria))
        }
      })

      const productsPromises = produtos.map(produto => {
        switch (produto.nome) {
          case "Linguiça Salsichão":
            return api.post("/api/estoque/cadastrar", handleDataProduto(linguica, jogo.jogo, { "produto": 7 }, res.data.industria))
          case "Peito de Frango":
            return api.post("/api/estoque/cadastrar", handleDataProduto(frango, jogo.jogo, { "produto": 8 }, res.data.industria))
          case "Coxa de Frango":
            return api.post("/api/estoque/cadastrar", handleDataProduto(frangoCorte, jogo.jogo, { "produto": 9 }, res.data.industria))
          case "Batata Frita":
            return api.post("/api/estoque/cadastrar", handleDataProduto(batata, jogo.jogo, { "produto": 10 }, res.data.industria))
        }
      })

      await Promise.all(insumosPromises)
      await Promise.all(productsPromises)

      fetchIndustries()
      clearAll()
      setShowInputToAddIndustry(false)

    } catch (e) {
      console.log(e);
    } finally {
      setLoading(true)
    }

  }

  async function deleteIndustry(id) {
    try {
      const res = await axios.delete(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/industria/apagar/${id}`)
      if (res.data.mensagem === "Existem Usuários Vinculados à Industria!") {
        alert(`Não é possível excluir \n${res.data.mensagem}`)
        return
      }
      const industriesCopy = [...industries]
      const index = industries?.findIndex(industry => industry.industria === id)
      if (index === -1) return

      industriesCopy.splice(index, 1)

      setIndustries(industriesCopy)
      setShowLista(false)
    } catch (e) {
      console.log(e)
    }

  }

  function handleSetValue(value, setStateValue, isInsumo) {
    if (isInsumo) {
      if (setStateValue === "Pernil Suíno") {
        setPernil(Number(value))
      } else if (setStateValue === "Caixa (Papelão)") {
        setCaixaPapelao(Number(value))
      } else if (setStateValue === "Embalagem Plástica") {
        setSacoPlastico(Number(value))
      } else if (setStateValue === "Condimento") {
        setCondimento(Number(value))
      } else if (setStateValue === "Frango P") {
        setFrangoP(Number(value))
      } else if (setStateValue === "Frango L") {
        setFrangoL(Number(value))
      } else {
        setBatataInsumo(Number(value))
      }
    } else {
      if (setStateValue === "Linguiça Salsichão") {
        setLinguica(Number(value))
      } else if (setStateValue === "Peito de Frango") {
        setFrango(Number(value))
      } else if (setStateValue === "Coxa de Frango") {
        setFrangoCorte(Number(value))
      } else if (setStateValue === "Batata Frita") {
        setBatata(Number(value))
      }
    }

  }

  function handleValue(value, isInsumo) {
    if (isInsumo) {
      if (value === "Pernil Suíno") {
        return pernil
      } else if (value === "Caixa (Papelão)") {
        return caixaPapelao
      } else if (value === "Embalagem Plástica") {
        return sacoPlastico
      } else if (value === "Condimento") {
        return condimento
      } else if (value === "Frango P") {
        return frangoP
      } else if (value === "Frango L") {
        return frangoL
      } else {
        return batataInsumo
      }
    } else {
      if (value === "Linguiça Salsichão") {
        return linguica
      } else if (value === "Peito de Frango") {
        return frango
      } else if (value === "Coxa de Frango") {
        return frangoCorte
      } else if (value === "Batata Frita") {
        return batata
      }
    }



  }

  function removeUserFromIndustry(userId, industryId) {

    api.delete(`/api/usuario/removerUsuarioIndustria/${industryId}/${userId}`)
      .then(response => {
        api.get(`/api/usuario/listarSemIndustria/${jogo?.jogo}`)
          .then(response => {
            setListaUsers(response.data)
            api.get(`/api/usuario/listarPorIndustria/${industryId}`)
              .then(response => setListaPlayers(response.data))
              .catch(error => {
                return Promise.reject(error)
              })
          })
          .catch(error => {
            return Promise.reject(error)
          })
      })
      .catch(error => {
        return Promise.reject(error)
      })

  }

  function atualizaUser(player) {
    const data = {
      "admin": player.admin,
      "login": player.login,
      "nome": player.nome,
      "senha": "123",
      "supermercado": null,
      "usuario": player.usuario
    }

    api.post("/api/usuario/atualizar", data)
      .then(response => console.log(response))


  }

  async function fetchBaseIndustries(industriesInGame) {
    try {
      api.get(`/api/industria/listarBase`)
        .then(response => {
          const mapToFiltered = industriesInGame.map(item => item.nome)
          const filteredIndustries = response.data.filter(industry => {
            return !mapToFiltered.includes(industry?.nome)
          })
          setIndustriesBase(filteredIndustries)
        })
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchIndustries() {
    try {
      api.get(`/api/industria/listar/${jogo?.jogo}`)
        .then(response => {
          setIndustries(response.data)
          fetchBaseIndustries(response.data)
        })
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchInsumos() {
    try {
      api.get("/api/insumo/listarTodos")
        .then(response => setInsumos(response.data))
    } catch (error) {
      console.log(error)
    }
  }

  function clearAll() {
    setLinguica(0)
    setFrango(0)
    setFrangoCorte(0)
    setBatata(0)
    setPernil(0)
    setBatataInsumo(0)
    setSacoPlastico(0)
    setCaixaPapelao(0)
    setFrangoP(0)
    setFrangoL(0)
    setCondimento(0)
    setNameIndustry('')
  }

  async function fetchActiveGame() {
    try {
      const response = await api.get("/api/jogo/obterJogoAtivo")
      const res = await api.get(`/api/rodada/obterRodadaAtiva/${response.data?.jogo}`)
      setJogo(response.data)
      setRodada(res.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchActiveGame()
  }, [])

  useEffect(() => {
    if (!jogo?.jogo) return
    fetchProducts()
    fetchIndustries()
    fetchInsumos()
  }, [jogo])

  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Indústria" />
        <BackButton path="/menuIndustry" />

        <ContainerStock style={{
          marginBottom: 12
        }}>
          <span>
            Jogo ativo
          </span>

          <Wrapper>
            <UserDiv>
              {jogo?.jogo ? (
                <>
                  <span>Iniciado por {jogo?.criacaoUsuario?.nome}</span>
                  <span style={{ lineHeight: 2 }}>Jogo criado em {new Date(String(jogo?.criacaoData)).toLocaleDateString()}</span>
                  <span>Número de rodadas: {jogo?.rodadas}</span>
                  <span style={{ lineHeight: 2 }}>Rodada ativa atualmente: {rodada?.numero}</span>
                </>
              ) : (
                <span>Nenhum jogo ativo, inicie um novo jogo</span>
              )}
            </UserDiv>
          </Wrapper>

        </ContainerStock>
        <Title>
          Número de Indústrias <span>{industries?.length ?? 0}</span>
        </Title>
        <MainContainer>

          {/* <div>
            <ButtonsDiv >
              <ButtonCompanies onClick={() => handleNewGame()} style={{background: "red"}} >Iniciar Novo Jogo</ButtonCompanies>
            </ButtonsDiv>
          </div> */}

          <ButtonsDiv >
            <ButtonAddCompanies onClick={() => setShowInputToAddIndustry(!showInputToAddIndustry)} >+</ButtonAddCompanies>
          </ButtonsDiv>

          {

            showInputToAddIndustry ? (
              <>
                <ButtonsDiv style={{
                  width: '100%',
                  flexDirection: 'row',
                  flexWrap: 'wrap'
                }}>
                  {industriesBase?.map(industry => (
                    <ButtonCompanies
                      style={nameIndustry === industry?.nome ? {
                        height: 48,
                        padding: '0 15px',
                        border: 'solid 5px #FFA500'
                      } : { height: 48, padding: '0 15px' }}
                      key={industry?.id}
                      onClick={() => {
                        if (nameIndustry === industry?.nome) {
                          setNameIndustry('')
                        } else {
                          setNameIndustry(industry?.nome)
                        }
                      }} >{industry.nome}</ButtonCompanies>
                  ))
                  }
                </ButtonsDiv>
                {nameIndustry.length > 0 ? (
                  <>
                    <ContainerStock>
                      <span>
                        <img src="./images/stock.svg" alt="icon_stock" />
                        Escolha o estoque inicial dos produtos
                      </span>
                      <section>
                        {produtos?.map((produto, key) => {
                          return (
                            <CardInsumo key={key}>
                              <img src={imagesProduto[key]} />
                              <h2>{produto.nome}</h2>
                              <div>
                                <input type={"number"} value={handleValue(produto.nome, false)} onChange={(e) => handleSetValue(e.target.value, produto.nome, false)} />
                                <p>
                                  {produto.nome === "Embalagem Plástica" ?
                                    "Milhei." :
                                    produto.nome === "Caixa (Papelão)" ?
                                      "Uni." :
                                      "Kg"
                                  }
                                </p>
                              </div>
                            </CardInsumo>
                          )
                        })}
                      </section>
                    </ContainerStock>

                    <ContainerStock>
                      <span>
                        <img src="./images/stock.svg" alt="icon_stock" />
                        Escolha o estoque inicial dos insumos
                      </span>
                      <section>
                        {insumos?.map((insumo, key) => {
                          let imageURL = null
                          if (insumo.nome === "Frango P") {
                            imageURL = "./images/chicken_p.svg"
                          } else if (insumo.nome === "Caixa (Papelão)") {
                            imageURL = "./images/box.svg"
                          } else if (insumo.nome === "Pernil Suíno") {
                            imageURL = "./images/pig.svg"
                          }
                          return (
                            <CardInsumo key={key}>
                              <img src={imageURL ?? insumo.urlImagem} />
                              <h2>{insumo.nome}</h2>
                              <div>
                                <input type={"number"} value={handleValue(insumo.nome, true)} onChange={(e) => handleSetValue(e.target.value, insumo.nome, true)} />
                                <p>
                                  {insumo.nome === "Embalagem Plástica" ?
                                    "Milhei." :
                                    insumo.nome === "Caixa (Papelão)" ?
                                      "Uni." :
                                      "Kg"
                                  }
                                </p>
                              </div>
                            </CardInsumo>
                          )
                        })}
                      </section>
                      <div role="button" onClick={loading ? () => { } : handleAddIndustry} style={{
                        marginTop: 10,
                        padding: '20px',
                        fontSize: 18,
                        fontWeight: 'bold',
                        backgroundColor: '#4bb543',
                        cursor: 'pointer',
                        textAlign: 'center'
                      }}>
                        Confirmar
                      </div>
                    </ContainerStock>

                  </>
                ) : null

                }

              </>
            ) : null

          }

          <span>Indústrias ativas no jogo atual</span>
          {industries?.length === 0 ? (
            <div>
              {jogo.jogo ? (
                <span style={{ fontSize: 16 }}>Nenhuma industria cadastrada para o jogo atual.</span>
              ) : (
                <span>Nenhum jogo ativo.</span>
              )

              }

            </div>
          ) : (
            industries?.map((industry, k) => {
              return (
                <div key={k}>
                  <ButtonsDiv  >
                    <ButtonCompanies onClick={() => listAllPlayers(industry)} >{industry.nome}</ButtonCompanies>
                    <ButtonDeleteCompanies onClick={() => deleteIndustry(industry.industria, industry.nome)} >X</ButtonDeleteCompanies>
                  </ButtonsDiv>
                </div>
              )
            })
          )
          }


          {
            showLista ? (
              <UserDiv style={{ marginBottom: 30 }}>
                <span>Jogadores em {idIndustria.nome}:</span>
                <ListPlayers>
                  {listaPlayers?.length ?
                    listaPlayers.map((player, key) => {

                      return <div>
                        <ButtonDeleteCompanies onClick={() => removeUserFromIndustry(player.usuario, idIndustria.industria)} >X</ButtonDeleteCompanies>
                        <span onClick={() => atualizaUser(player)} key={key}>{player.nome} | {player.login}</span>

                      </div>
                    }) :
                    (

                      <span>Não há nenhum jogador nessa indústria, para adicionar clique no botão abaixo</span>

                    )
                  }

                </ListPlayers>

                {showAllUsers &&
                  <>
                    <span>Usuarios:</span>
                    <ListPlayers>

                      {listaUsers?.length ?
                        listaUsers.map((user, key) => {

                          return <div>
                            <span key={key}><ButtonAddCompanies onClick={() => addUserToIndustry(user, idIndustria)} >+</ButtonAddCompanies>{user.nome} | {user.login}</span>
                          </div>
                        }) :
                        (

                          <span>Todos os jogadores já estão vinculados a uma industria</span>

                        )
                      }


                    </ListPlayers>
                  </>
                }

                {!showAllUsers &&
                  <ButtonCompanies style={{ color: "orange", background: "#fff" }} onClick={() => listAllUsers()} >Adicionar Novo Jogador</ButtonCompanies>
                }


              </UserDiv>


            ) : (<></>)
          }
          <ButtonRequest>EXPORTAR</ButtonRequest>
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default SetupIndustry;
